import { render, staticRenderFns } from "./expenseCategorySettings.vue?vue&type=template&id=44ed84e0&scoped=true"
import script from "./expenseCategorySettings.vue?vue&type=script&lang=js"
export * from "./expenseCategorySettings.vue?vue&type=script&lang=js"
import style0 from "./expenseCategorySettings.vue?vue&type=style&index=0&id=44ed84e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed84e0",
  null
  
)

export default component.exports